export default {"src":"/_next/static/media/icon_impenetrable_security.ef6310c9.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};